import * as React from 'react';

// InfoWindow Component
export const InfoWindow = (props: any) => {
    const { place } = props;

    return (
        <div className="info-window">
            <div>{place.label}</div>
        </div>
    );
};

// Marker Component
export const Marker = (props: any) => {

    return (
        <React.Fragment>
            <div className={`marker-style ${ props.useMiniMarker ? 'mini' : '' }  ${ props.way.show ? 'selected' : '' }`}>
                {
                    props.way.isOrigin
                        ? <i className="la la-home" />
                        : props.index
                }
            </div>
            { props.way.show && <InfoWindow place={props.way} /> }
        </React.Fragment>
    );
};

// Marker Component
export const PushPin = (props: any) => {

    return (<a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${props.lat},${props.lng}` } className="pushpin-style">
        <i className="la la-home" />
    </a> 
    );
};

// No Result Component
export const NoResultItem = (props: any) => {
    return <div />;
};
